import { render } from "./NotFound.vue?vue&type=template&id=6f1f59fc"
const script = {}

import exportComponent from "/builds/n-Zh5gRSP/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__